import { useCallback } from "react";
import {
  TagSearchResultsItemV2,
  TagSearchResultsResponseV2,
} from "@/apis/taxonomy/types";
import { MappingSearchResultGroup } from "../retrieval-results/group";
import EmptySearchResult from "./empty-search-result";
import SearchTagListItem from "./search-tag-list-item";

const SearchResults = ({
  prevQuery,
  data,
  selectedTag,
  setSelectedTag,
  selectedContainerTag,
  setSelectedContainerTag,
  onButtonClickCommonAction,
}: {
  prevQuery: string;
  data?: TagSearchResultsResponseV2;
  selectedContainerTag: TagSearchResultsItemV2 | null;
  selectedTag: TagSearchResultsItemV2 | null;
  setSelectedContainerTag: (tag: TagSearchResultsItemV2 | null) => void;
  setSelectedTag: (tag: TagSearchResultsItemV2 | null) => void;
  onButtonClickCommonAction: () => void;
}) => {
  const handleSelect = useCallback(
    (
      tag: TagSearchResultsItemV2,
      containerTag: TagSearchResultsItemV2 | null,
    ) => {
      setSelectedTag(tag);
      setSelectedContainerTag(containerTag);
    },
    [setSelectedTag, setSelectedContainerTag],
  );

  return (
    <>
      {data?.tags && data?.tags.length > 0 ? (
        <>
          {data?.tags.map((result) => {
            const children = result.items.map((item) => {
              const isSelected =
                selectedTag?.id === item.id &&
                selectedContainerTag?.id === result.containerTag?.id;

              return (
                <div
                  key={item.id}
                  className={`self-stretch ${result.containerTag ? "" : "px-4"}`}
                >
                  <SearchTagListItem
                    tag={item}
                    isSelected={isSelected}
                    originalRoleKey={result.roleKey ?? null}
                    containerTag={result.containerTag}
                    onSelect={handleSelect}
                    onClickAfterAction={onButtonClickCommonAction}
                  />
                </div>
              );
            });
            if (result.containerTag) {
              return (
                <MappingSearchResultGroup
                  key={result.containerTag?.id}
                  label={result.containerTag?.koLabel ?? ""}
                  showTotalCount
                >
                  {children}
                </MappingSearchResultGroup>
              );
            } else {
              return <div className="flex flex-col gap-2">{children}</div>;
            }
          })}
        </>
      ) : (
        <EmptySearchResult prevQuery={prevQuery} />
      )}
    </>
  );
};

export default SearchResults;
